/**
 * @module views\mon\inventory
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";

@Component
export default class Inventory extends GhBase {
  private args = { keyword: "" };
}
